import React, { useState } from 'react';
import { EventsTable } from 'src/domains/sportsbook/webview/components/eventsTable/EventsTable';
import { HomepageUnifiedEventsSection } from 'src/domains/sportsbook/webview/components/containers/homepageUnifiedEventsSection/HomepageUnifiedEventsSection';
import { FilterKindType } from 'src/domains/sportsbook/webview/components/eventsFilters/EventsFilterType';
import { computed, makeObservable } from 'mobx';
import { EventsCollectionList } from 'src/domains/sportsbook/state/eventsCollection/EventsCollectionList';
import { observer } from 'src/utils/mobx-react';
import { EventsTableHeaderStyle } from 'src/domains/sportsbook/webview/components/eventsTable/EventsMainSectionWrapper';
import { Common, useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { EventsCollectionState } from 'src/domains/sportsbook/state/eventsCollection/EventsCollectionState';
import { LanguagesState } from 'src/domains/layouts/state/languagesState/LanguagesState';
import { FiltersSkin } from 'src/domains/layouts/webview/components/filters/FiltersSkin';
import { isValidEventItem } from 'src/domains/sportsbook/utils/isOutrightEvent';

const filters: Array<FilterKindType> = ['sport'];

class InPlayState {
    public constructor(private readonly common: Common) {
        makeObservable(this);
    }

    @computed public get inPlayEventsCollection(): EventsCollectionList {
        const { unifiedSportEventsTable } = ConfigComponents.get(this.common).unifiedComponentConfig;
        const listInPlay = EventsCollectionState.get(this.common).listInPlay;

        return unifiedSportEventsTable
            ? listInPlay.filterBySportAndEvent((_sport, event): boolean => isValidEventItem(event))
            : listInPlay;
    }

    public get tableLabel(): string {
        return LanguagesState.get(this.common).getTranslation('special-box.header.in-play', 'In play');
    }
}

interface PropsType {
    showPriceLegend: boolean;
    isLoading: boolean;
}

export const InPlay = observer('InPlay', (props: PropsType) => {
    const common = useCommon();
    const { unifiedSportEventsTable, filtersVersion } = ConfigComponents.get(common).unifiedComponentConfig;
    const [inPlayState] = useState(() => new InPlayState(common));

    if (unifiedSportEventsTable === true) {
        return (
            <HomepageUnifiedEventsSection
                collection={inPlayState.inPlayEventsCollection}
                dataTest='in-play'
                filters={filters}
                filterVersion={FiltersSkin.TERTIARY}
                filtersWithBadge
                hideWhenEmpty={true}
                isLoading={props.isLoading}
                showPriceLegend={props.showPriceLegend}
                title={inPlayState.tableLabel}
            />
        );
    }

    return (
        <EventsTable
            headerStyle={EventsTableHeaderStyle.SOLID}
            filterVersion={filtersVersion.inPlay}
            icon='in-play'
            title={inPlayState.tableLabel}
            showHeaderSport={true}
            allGroupsOpen={true}
            eventsCollection={inPlayState.inPlayEventsCollection}
            filters={filters}
            isTogglable={true}
            showPriceLegend={props.showPriceLegend}
            isLoading={props.isLoading}
            dataTest='in-play'
            hideNoEventsMessage={true}
            isAmericanFootball={false}
        />
    );
});
